"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CustomChargeStore = require("../../../stores/CustomChargeStore.jsx");

var _CustomChargeStore2 = _interopRequireDefault(_CustomChargeStore);

var _CartStore = require("../../../stores/CartStore.jsx");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Utility = require("../../../utils/Utility.jsx");

var Utils = _interopRequireWildcard(_Utility);

var _reactTooltip = require("react-tooltip");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Actions = require("../../../Actions.jsx");

var _Actions2 = _interopRequireDefault(_Actions);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var OptionalChargeView = function (_React$Component) {
    _inherits(OptionalChargeView, _React$Component);

    function OptionalChargeView(props) {
        _classCallCheck(this, OptionalChargeView);

        return _possibleConstructorReturn(this, (OptionalChargeView.__proto__ || Object.getPrototypeOf(OptionalChargeView)).call(this, props));

        // this.state = {
        //     isMobile: false
        // };
    }

    _createClass(OptionalChargeView, [{
        key: "isCurbsidePickUpEnabled",
        value: function isCurbsidePickUpEnabled() {

            // check the ordertype is PickUp and Curbside PickUp option is selected
            if (this.props.orderType == PICKUP && _CartStore2.default.getIsPreferCurbsideEnabled()) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: "getCustomChargesOptionalStructure",
        value: function getCustomChargesOptionalStructure() {
            var _this2 = this;

            if (_CustomChargeStore2.default.isCustomChargeConfigured()) {

                var orderType = null;
                if (this.isCurbsidePickUpEnabled()) {
                    orderType = CURBSIDEPICKUP;
                } else {
                    orderType = this.props.orderType;
                }

                var optionalCharge = _CustomChargeStore2.default.getCustomChargeConfig(orderType, "O");

                if (optionalCharge && optionalCharge.length > 0) {

                    return optionalCharge.map(function (charge, index) {

                        var valuesObj = charge.typeDetails.values;

                        // if viewType is not configured then we consider to show the options as a ROW
                        // We have 2 Options ROW | COLUMN for display the data
                        var viewType = "Row"; // Column
                        if (!Utils.isEmptyObj(charge.typeDetails) && !Utils.isEmpty(charge.typeDetails.viewType)) {
                            viewType = charge.typeDetails.viewType;
                        }
                        // get the default selected charges
                        var defaultCharge = _CartStore2.default.getDefaultOptionalCharge();

                        var defaultIndex = null;

                        if (defaultCharge.length > 0) {
                            var chargeObj = defaultCharge.find(function (charge) {
                                return charge.chargeObjIdx == index;
                            });

                            if (!Utils.isEmptyObj(chargeObj)) {
                                defaultIndex = chargeObj.defaultIdx;
                            }
                        }

                        /*
                        * Checked if name exists and custom button is false then
                        * Showing the 1st option with checkbox otherwise
                        * Showing the 2nd option without label
                        * */

                        // if (isNameExist && isCustomOptionEnabled != true) {
                        if (viewType == "Row") {
                            // Show the charge options in a row format
                            return _this2.optionalChargeType(charge, index, defaultIndex);
                        } else {
                            // Show the charge options in a column format
                            return _this2.optionalChargeTypeAsColumn(charge, index, defaultIndex);
                        }
                    });
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    }, {
        key: "optionalChargeType",
        value: function optionalChargeType(charge, chargeObjIdx, defaultIndex) {

            var longDesc = charge.desc;

            var chargeTypeValues = charge.typeDetails.values;

            var descComponent = null;
            if (!Utils.isEmpty(longDesc)) {
                descComponent = _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                        "a",
                        { "data-tip": longDesc, className: 'color-styl tooltip-button',
                            style: { cursor: 'pointer' },
                            tabIndex: 42
                        },
                        _react2.default.createElement("i", { className: "fa fa-info-circle" })
                    ),
                    _react2.default.createElement(_reactTooltip2.default, { place: "right", wrapper: "span" })
                );
            }

            var chargeLogo = false;

            if (charge && charge.typeDetails && charge.typeDetails.logoURL) {
                Utils.checkIfImageExists(charge.typeDetails.logoURL, function (exists) {
                    if (exists) {
                        // Success code
                        chargeLogo = true;
                    }
                });
            }

            var component = _react2.default.createElement(
                "div",
                { key: chargeObjIdx, className: "row optional-main mb-10" },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-12" },
                    _react2.default.createElement(
                        "h6",
                        null,
                        charge.name,
                        " ",
                        descComponent
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "btn-group btn-group-justified center-block " },
                        _react2.default.createElement(
                            "table",
                            { className: "table-option-cusotm " },
                            _react2.default.createElement(
                                "tbody",
                                null,
                                _react2.default.createElement(
                                    "tr",
                                    null,
                                    chargeLogo ? _react2.default.createElement(
                                        "td",
                                        { className: "rounded-item-td" },
                                        _react2.default.createElement(
                                            "div",
                                            { className: "media" },
                                            _react2.default.createElement(
                                                "a",
                                                { href: charge.typeDetails.infoLink, target: "_blank", tabIndex: 43 },
                                                _react2.default.createElement("img", {
                                                    src: charge.typeDetails.logoURL,
                                                    title: "Health Logo Title",
                                                    alt: "Health Logo Title",
                                                    className: "img-in-cart-1 img-rounded img-fluid rounded-sm" })
                                            )
                                        )
                                    ) : null,
                                    _react2.default.createElement(
                                        "td",
                                        { className: "col-11 rounded-item-td", style: { textAlign: 'left' } },
                                        _react2.default.createElement(
                                            "div",
                                            null,
                                            _react2.default.createElement(
                                                "h4",
                                                { className: "item-in-cart" },
                                                charge.typeDetails.name
                                            ),
                                            _react2.default.createElement(
                                                "h5",
                                                { className: "ft-14" },
                                                charge.typeDetails.desc
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        this.loadOptionalOptionView(chargeTypeValues, defaultIndex, chargeObjIdx, charge)
                    )
                )
            );
            return component;
        }
    }, {
        key: "loadOptionalOptionView",
        value: function loadOptionalOptionView(chargeTypeValues, defaultIndex, chargeObjIdx, chargeObject) {
            var _this3 = this;

            if (chargeTypeValues && chargeTypeValues.length > 0) {

                // discounted subtotal
                var totalValue = _CartStore2.default.getCartSubTotalWithDiscountRounded();

                return chargeTypeValues.map(function (value, index) {

                    var optionDesc = _CustomChargeStore2.default.showPercentageOrFixed(value);
                    var perFixedComponent = null;
                    if (optionDesc != null && !Utils.isEmpty(optionDesc)) {
                        perFixedComponent = _react2.default.createElement(
                            "span",
                            null,
                            _react2.default.createElement(
                                "a",
                                { "data-tip": optionDesc, className: 'color-styl tooltip-button',
                                    style: { cursor: 'pointer' }, tabIndex: 45
                                },
                                _react2.default.createElement("i", {
                                    className: "fa fa-info-circle"
                                })
                            ),
                            _react2.default.createElement(_reactTooltip2.default, { place: "right", wrapper: "span" })
                        );
                    }

                    var component = _react2.default.createElement(
                        "div",
                        { key: index, className: "optional-option-div", id: index },
                        _react2.default.createElement("span", { className: "col-12 option-charge-line d-block" }),
                        _react2.default.createElement(
                            "div",
                            { className: " checkbox-div" },
                            _react2.default.createElement(
                                "label",
                                {
                                    className: "container-checkbox remove-margin-top pull-left chk-lbl cart-header" },
                                _react2.default.createElement(
                                    "b",
                                    null,
                                    value.name,
                                    " ",
                                    perFixedComponent
                                ),
                                _react2.default.createElement(
                                    "h5",
                                    { className: "optional-option text-secondary-light ft-14" },
                                    "$",
                                    _CustomChargeStore2.default.getCalculateFeeOfCharge(value, totalValue)
                                ),
                                _react2.default.createElement("input", { type: "checkbox",
                                    id: index
                                    // key={chargeObj}
                                    , name: "round-off-name",
                                    defaultChecked: defaultIndex === index,
                                    onClick: function onClick(event) {
                                        return _this3.clickedToggleCheckbox(chargeObjIdx, index, event, value, chargeObject);
                                    },
                                    tabIndex: 44
                                }),
                                _react2.default.createElement("span", { className: "checkmark checkmark-optional" })
                            ),
                            _react2.default.createElement("span", { className: "clearfix" })
                        )
                    );

                    return component;
                });
            } else {
                return null;
            }
        }
    }, {
        key: "clickedToggleCheckbox",
        value: function clickedToggleCheckbox(chargeObjIdx, index, event, chargeTypeDetailsValue, chargeObject) {

            var status = event.target.checked;

            _Actions2.default.updateDefaultOptionalCharge(chargeObjIdx, index, status, chargeTypeDetailsValue, chargeObject);
        }
    }, {
        key: "optionalChargeTypeAsColumn",
        value: function optionalChargeTypeAsColumn(charge, optionalChargeIdx, defaultIndex) {

            var longDesc = charge.typeDetails.desc;

            var descComponent = null;
            if (!Utils.isEmpty(longDesc)) {
                descComponent = _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                        "a",
                        { "data-tip": longDesc, className: 'color-styl tooltip-button',
                            style: { cursor: 'pointer' },
                            tabIndex: 46
                        },
                        _react2.default.createElement("i", { className: "fa fa-info-circle" })
                    ),
                    _react2.default.createElement(_reactTooltip2.default, { place: "right", wrapper: "span" })
                );
            }

            var chargeTypeValues = charge.typeDetails.values;

            var chargeLogo = false;

            if (charge && charge.typeDetails && charge.typeDetails.logoURL) {
                Utils.checkIfImageExists(charge.typeDetails.logoURL, function (exists) {
                    if (exists) {
                        // Success code
                        chargeLogo = true;
                    }
                });
            }

            var component = _react2.default.createElement(
                "div",
                { key: optionalChargeIdx, className: "row optional-main mt-2" },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-12" },
                    _react2.default.createElement(
                        "h4",
                        { className: "round-off-heading f16-default" },
                        charge.name,
                        " ",
                        descComponent
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "btn-group btn-group-justified center-block" },
                        _react2.default.createElement(
                            "table",
                            { className: "table mb-0" },
                            _react2.default.createElement(
                                "tbody",
                                null,
                                _react2.default.createElement(
                                    "tr",
                                    null,
                                    chargeLogo ? _react2.default.createElement(
                                        "td",
                                        { className: "rounded-item-td" },
                                        _react2.default.createElement(
                                            "div",
                                            { className: "media" },
                                            _react2.default.createElement(
                                                "a",
                                                { href: charge.typeDetails.infoLink, target: "_blank", tabIndex: 47 },
                                                _react2.default.createElement("img", {
                                                    src: charge.typeDetails.logoURL,
                                                    title: "Health Logo Title",
                                                    alt: "Health Logo Title",
                                                    className: "img-in-cart-1 rounded-sm img-responsive" })
                                            )
                                        )
                                    ) : null,
                                    _react2.default.createElement(
                                        "td",
                                        { className: "col-11 rounded-item-td", style: { textAlign: 'left' } },
                                        _react2.default.createElement(
                                            "div",
                                            null,
                                            _react2.default.createElement(
                                                "h4",
                                                { className: "item-in-cart" },
                                                charge.typeDetails.name
                                            ),
                                            _react2.default.createElement(
                                                "h5",
                                                { className: "ft-14" },
                                                charge.typeDetails.desc
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "row tip-main" },
                            _react2.default.createElement(
                                "div",
                                { className: "col-md-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "custom_charge_container" },
                                    this.loadCustomOptionalOptionView(chargeTypeValues, optionalChargeIdx, defaultIndex, charge)
                                )
                            )
                        )
                    ),
                    _react2.default.createElement("span", { className: "col-12 mb-0 cart_border d-inline-block" })
                )
            );
            return component;
        }
    }, {
        key: "loadCustomOptionalOptionView",
        value: function loadCustomOptionalOptionView(chargeTypeValues, optionalChargeIdx, defaultIndex, chargeObj) {
            var _this4 = this;

            if (chargeTypeValues && chargeTypeValues.length > 0) {

                // discounted subtotal
                var totalValue = _CartStore2.default.getCartSubTotalWithDiscountRounded();

                return chargeTypeValues.map(function (value, index) {

                    var className = "btn btn-tip btn-button-link btn-custom-charges";
                    var activeStatus = false;
                    if (defaultIndex == index) {
                        className = "btn btn-tip btn-button-link active-styl";
                        activeStatus = true;
                    } else {
                        activeStatus = false;
                    }

                    var component = _react2.default.createElement(
                        "div",
                        { key: index, className: "checkbox-div common-charge " + (chargeTypeValues.length >= 3 ? "common-charge-container" : "") },
                        _react2.default.createElement(
                            "label",
                            {
                                className: "container-checkbox remove-margin-top pull-left chk-lbl" },
                            _react2.default.createElement(
                                "b",
                                null,
                                "$",
                                _CustomChargeStore2.default.getCalculateFeeOfCharge(value, totalValue)
                            ),
                            _react2.default.createElement("br", null),
                            _react2.default.createElement("input", { type: "checkbox",
                                id: index
                                // key={chargeObj}
                                , name: "optional-charge-checkbox",
                                checked: defaultIndex === index,
                                onClick: function onClick(event) {
                                    return _this4.clickedTapOption(optionalChargeIdx, index, event, value, activeStatus, chargeObj);
                                },
                                tabIndex: 48
                            }),
                            _react2.default.createElement("span", { className: "checkmark checkmark-optional new-charge-container" })
                        ),
                        _react2.default.createElement("span", { className: "clearfix" })
                    );

                    return component;
                });
            } else {
                return null;
            }
        }
    }, {
        key: "clickedTapOption",
        value: function clickedTapOption(optionalChargeIdx, index, event, chargeTypeDetailsValue, activeStatus, chargeObj) {

            var buttonStatus = !activeStatus;

            // discounted subtotal
            // let totalValue = CartStore.getCartSubTotalWithDiscountRounded();

            _Actions2.default.updateDefaultOptionalCharge(optionalChargeIdx, index, buttonStatus, chargeTypeDetailsValue, chargeObj);
        }
    }, {
        key: "applyCustomChargeFee",
        value: function applyCustomChargeFee(optionalChargeIdx, chargeObj, customFieldId) {

            var customFieldIdValue = document.getElementById(customFieldId).value;

            if (customFieldIdValue < 0) {

                _sweetalert2.default.fire({
                    title: 'Invalid Value!',
                    text: 'You are entering a negative value.',
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                });

                return;
            } else if (Utils.isEmpty(customFieldIdValue)) {

                _sweetalert2.default.fire({
                    title: 'Warning!',
                    text: 'Text field is empty',
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                });

                return;
            } else {
                _Actions2.default.updateCustomFieldValue(optionalChargeIdx, chargeObj, customFieldIdValue);
            }
        }
    }, {
        key: "clickedTapOptionCustomBtn",
        value: function clickedTapOptionCustomBtn(optionalChargeIdx, chargeObj, activeStatus) {

            var buttonStatus = !activeStatus;

            _Actions2.default.updateDefaultOptionalChargeCustom(optionalChargeIdx, buttonStatus, chargeObj);
        }
    }, {
        key: "render",
        value: function render() {

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.getCustomChargesOptionalStructure()
            );
        }
    }]);

    return OptionalChargeView;
}(_react2.default.Component);

exports.default = OptionalChargeView;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/custom-charge/OptionalChargeView.jsx
// module id = 736
// module chunks = 0